<template>
  <div class="tpage">
    <div class="topbar">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.push('/thome')">返回</el-button>
      <span class="title">教务管理</span>
      <span class="topbar-pad"></span>
    </div>

    <div class="body">
      <div class="grid">
        <div class="grid-item" v-for="item in menus" :key="item.text" @click="open(item)">
          <i :class="item.icon"></i>
          <span>{{ item.text }}</span>
          <em v-if="!item.ready" class="soon">迁移中</em>
        </div>
      </div>

      <p class="hint" v-if="checked && !limit">
        您暂无教务管理权限（需归属「教学中心」），如需使用请联系教务处。
      </p>
    </div>
  </div>
</template>

<script>
import { teacherProfile, getTeacherLogin } from '@/api/teacher.js'

export default {
  name: 'TeacherEdu',
  data() {
    return {
      limit: true,
      checked: false,
      menus: [
        { text: '查课登记', icon: 'el-icon-edit-outline', path: '/tedu-register', ready: true },
        { text: '教师登记', icon: 'el-icon-user', path: '/tedu-teacher', ready: true },
        { text: '登记记录', icon: 'el-icon-tickets', path: '/tedu-record', ready: true }
      ]
    }
  },
  mounted() {
    if (!getTeacherLogin().token) {
      this.$router.replace('/tlogin')
      return
    }
    // 与小程序的权限判断一致：部门含「教学中心」才可使用
    teacherProfile()
      .then((res) => {
        this.checked = true
        if (res.code === 401) {
          this.$router.replace('/tlogin')
          return
        }
        if (res.code === 0 && res.data) {
          this.limit = res.data.education_limit === 1
        }
      })
      .catch(() => {
        this.checked = true
      })
  },
  methods: {
    open(item) {
      if (!item.ready) {
        this.$message.info('该功能网页端暂未开放，请稍后再试')
        return
      }
      if (!this.limit) {
        this.$message.warning('暂无教务管理权限')
        return
      }
      this.$router.push(item.path)
    }
  }
}
</script>

<style scoped lang="scss">
.tpage {
  min-height: 100vh;
  background: #f4f6fb;
}
.topbar {
  background: #fff;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef1f7;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
  .topbar-pad {
    width: 56px;
  }
}
.body {
  padding: 16px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.grid-item {
  position: relative;
  background: #fff;
  border-radius: 10px;
  padding: 18px 6px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.05);

  i {
    font-size: 26px;
    color: #3b6ef0;
  }
  span {
    font-size: 13px;
    color: #38445a;
  }
  .soon {
    position: absolute;
    top: 6px;
    right: 6px;
    font-size: 10px;
    font-style: normal;
    color: #b0b8c8;
    background: #f4f6fb;
    border-radius: 8px;
    padding: 1px 5px;
  }
  &:active {
    transform: scale(0.98);
  }
}
.hint {
  margin-top: 18px;
  font-size: 13px;
  color: #e6a23c;
  line-height: 1.6;
}
</style>
